import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi 🙋‍♂️, I am <span className="purple">Nguyen Viet Anh Minh </span>
            come from <span className="purple"> Kon Tum, Vietnam.</span>
            <br />
            <br />
            I have a strong passion for exploring new technologies and
            harnessing them to solve real-life problems 👨🏻‍💻. <br />
            Besides, I am very funny, friendly and really like to confide 😆.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Sports
            </li>
            <li className="about-activity">
              <ImPointRight /> Content Creators
            </li>
            <li className="about-activity">
              <ImPointRight /> Traveling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Soumyajit Behera</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
